import Quill from 'quill/core';

import Toolbar from 'quill/modules/toolbar';
import Snow from 'quill/themes/snow';

import Bold from 'quill/formats/bold';
import Italic from 'quill/formats/italic';
import Header from 'quill/formats/header';
import Blockquote from 'quill/formats/blockquote';
import Underline from 'quill/formats/underline';
import CodeBlock from 'quill/formats/code';
import Link from 'quill/formats/link';

import List, { ListItem } from 'quill/formats/list';
import { FontClass, FontStyle } from 'quill/formats/font';
import { SizeClass, SizeStyle } from 'quill/formats/size';
import { AlignStyle, AlignClass, AlignAttribute } from 'quill/formats/align';
import { IndentClass as Indent } from 'quill/formats/indent';

Quill.register(AlignClass, true);
Quill.register(AlignStyle, true);
Quill.register(AlignAttribute, true);

Quill.register({
  'attributors/style/size': SizeStyle,
  'attributors/class/size': SizeClass,
  'attributors/style/font': FontStyle,
  'attributors/class/font': FontClass,
});

Quill.register({
  'modules/toolbar': Toolbar,
  'themes/snow': Snow,
  'formats/bold': Bold,
  'formats/underline': Underline,
  'formats/link': Link,
  'formats/blockquote': Blockquote,
  'formats/code-blcok': CodeBlock,
  'formats/italic': Italic,
  'formats/header': Header,
  'formats/list': List,
  'formats/indent': Indent,
  'formats/list/item': ListItem,
  'formats/font': FontClass,
  'formats/size': SizeClass
});

export default Quill;
